export interface User {
    user_id: string;
    user_name: string;
    user_email: string;
    created_at: string;
    user_tokens: number;
    updated_at: string;
    subscriptions: string;
  }
  
  export interface Session {
    session_id: string;
    user_id: number;
    created_at: string;
    name: string;
    session_type: SubscriptionEnum;
  }
  
  export interface SessionDetails {
    session_id: string;
    user_id: string;
    queries: Query[];
    answers: Answer[];
    suggestedQuestions: SuggestedQuestion[];
    searchResults: SearchResult[];
    session_type: SubscriptionEnum;
  }
  
  export interface Answer {
    query_id: number;
    session_id: number;
    answer_id: number;
    answer_text: string;
    created_at: string;
    cited_results: SearchResult[];
  }
  
  export interface SearchResult {
    result_id: number;
    query_id: number;
    url: string;
    title: string;
    created_at: string;
    updated_at: string;
    source_type: string;
    source_date: string;
    source_domain: string;
    snippet: string;
    full_text: string;
    embedding_vector: string;
  }
  
  export interface Query {
    session_id: string;
    query_id: number;
    query_text: string;
    created_at: string;
    suggestedQuestions: SuggestedQuestion[];
    searchResults: SearchResult[];
  }

  export interface SuggestedQuestion {
    query_id: number;
    suggested_question_id: number;
    session_id: number;
    question_text: string;
    created_at: string;
  }

  export interface Bookmark {
    user_id: number;
    answer_id: number;
    bookmark_id: number;
    created_at: string;
  }

  export enum SubscriptionEnum {
    RESEARCH = 'research',
    DILIGENCE = 'diligence',
    TAX = 'tax',
    PATENT = 'patent'
  }

  export enum SubscriptionDisplayName {
    research = 'Research',
    diligence = 'Diligence',
    tax = 'Tax',
    patent = 'Patent'
  }
